import configService from "@/services/configService.js";

const ConfigPlugin = {
  install(Vue) {
    // Attach service globally as $configService
    Vue.prototype.$configService = configService;
  }
};

export default ConfigPlugin;
